import angular from 'angular';

import UserService from './user.service'
import BranchService from './branch.service'
import CustomerService from './customer.service'
import TruckService from './truck.service'
import VaultService from './vault.service'
import BatchService from './batch.service'
import RouteService from './route.service'
import LocationService from './location.service'
import UsersService from './users.service'
import ContractService from './contract.service'
import ShiptypeService from './shiptype.service'
import WindowService from './window.service'
import CarrierService from './carrier.service'
import ScanService from './scan.service'
import ShipmentService from './shipment.service'
import MessageService from './message.service'
import LanguageService from './language.service'
import BagoutService from './bagout.service'
import PrefixService from './prefix.service'
import HolidayService from './holidays.service'
import RouteDetailService from './route-detail.service'
import SetupService from './setup.service'
import ItemService from './item.service'
import LogService from './log.service'
import ScanConfigService from './scan-config.service'
import HoldService from './hold.service'
import HoldLocationService from './hold-location.service'
import BypassCodeService from './bypass-code.service'
import IdStoreService from './id-store-service'
import HomeService from './home.service'
import TransactionService from './transaction.service'
import HoldVerifyService from './hold-verify.service'
import DailyStatService from './daily-stat.service'
import LocationDeliveryService from './location-delivery.service'
import CurrencyService from './currency.service'
import DenominationService from './denomination.service'
import BranchFundingSourceService from './branch-funding-source.service'
import BulkCashService from './bulk-cash.service'
import UserBranchService from './user-branch.service'
import OrderPackingService from './order-packing.service'
import LedgerService from './ledger.service'
import LedgerTransactionService from './ledger-transaction.service'
import AtmResidualService from './atm-residual.service'
import LocationBranchService from './location-branch.service'
import AtmResidualDepositService from './atm-residual-deposit.service'
import DailyBalanceSheetService from './daily-balance-sheet.service'
import MonthlyReportService from './monthly-report.service'
import AtmCodesManagementService from './atm-codes-management.service'
import MobileAppService from './mobile-app.service'
import RouteStopService from './route-stop.service'
// import AccountsService from './accounts.service'
import ResetAtmCodeService from './reset-atm-code.service'
// import MobileApiService from './mobile-api.service'
import RouteProgressService from './route-progress.service'
import CarrierBranchService from './carrier-branch.service'
import ServiceOrderService from './service-order.service'
import ActionCodeService from './action-code.service'
import VehicleLockerService from './vehicle-lockers.service'
import UserBranchFundingSourceService from './user-branch-funding-source.service'
import BranchPerformanceService from './branch-performance.service'
import CashDeliveriesService from './cash-deliveries.service'
import ReportService from './report.service'
import PhysicalCashCountService from './physical-cash-count.service'
import ConfigService from './config.service'
import LockOpenErrorService from './lock-open-errors.service'
import BillableEventsService from './billable-events.service'
import BillingCategoryService from './billing-category.service'
import BillingRecordsService from './billing-records.service'
import FuelSurchargeService from './fuel-surcharge.service'
import PricePointService from './price-point.service'
import CountVariancesService from './count-variances.service'
import VaultOperationsService from './vault-operations.service'
import RouteStatsService from './route-stats.service'
import BranchFundingSourceHolidayService from './branch-funding-source-holiday.service'
import BranchFundingSourceOrderProfileService from './branch-funding-source-order-profile.service'
import CommonLayoutService from './common-layout.service'
import OrderViewService from './order-view.service';
import RegionRoutingService from './region-routing.service';
import RestoreRouteAssignmentService from './restore-route-assignment.service'
import ServiceTicketPartsService from './service-ticket-parts.service'
import EnvironmentConfigService from './environment-config.service'
import ContactRequestService from './contact-request.service'
import ImportFileViewService from './import-file-view.service'
import StopSchedulingService from './stop-scheduling.service'
import CostCenterService from './cost-center.service';
import LocationZoneService from './location-zone.service';
import LocationDistanceService from './location-distance.service'
import ServiceChecklistService from './service-checklist.service';
import ItemTypeService from './item-type.service';
import ContractTypeService from './contract-type.service';
import AtmMakesService from './atm-makes.service';
import AutomatedRoutingStopsService from './automated-routing-stops.service';
import ServiceActionPrioritiesService from './service-action-priorities.service';

let servicesModule = angular.module('app.services', [])

    .factory('UserService', UserService)

    .factory('BranchService', BranchService)

    .factory('CustomerService', CustomerService)

    .factory('TruckService', TruckService)

    .factory('VaultService', VaultService)

    .factory('BatchService', BatchService)

    .factory('RouteService', RouteService)

    .factory('LocationService', LocationService)

    .factory('UsersService', UsersService)

    .factory('ContractService', ContractService)

    .factory('ShiptypeService', ShiptypeService)

    .factory('WindowService', WindowService)

    .factory('CarrierService', CarrierService)

    .factory('ScanService', ScanService)

    .factory('ShipmentService', ShipmentService)

    .factory('MessageService', MessageService)

    .factory('LanguageService', LanguageService)

    .factory('BagoutService', BagoutService)

    .factory('PrefixService', PrefixService)

    .factory('HolidayService', HolidayService)

    .factory('IdStoreService', IdStoreService)

    .factory('RouteDetailService', RouteDetailService)

    .factory('SetupService', SetupService)

    .factory('ItemService', ItemService)

    .factory('HoldService', HoldService)

    .factory('HoldLocationService', HoldLocationService)

    .factory('BypassCodeService', BypassCodeService)

    .factory('HomeService', HomeService)

    .factory('LogService', LogService)
    
    .factory('ScanConfigService', ScanConfigService)

    .factory('TransactionService', TransactionService)

    .factory('HoldVerifyService', HoldVerifyService)

    .factory('LocationDeliveryService', LocationDeliveryService)

    .factory('DailyStatService', DailyStatService)

    .factory('CurrencyService', CurrencyService)

    .factory('DenominationService', DenominationService)

    .factory('BranchFundingSourceService', BranchFundingSourceService)

    .factory('BulkCashService', BulkCashService)
    
    .factory('UserBranchService', UserBranchService)

    .factory('OrderPackingService', OrderPackingService)

    .factory('LedgerService', LedgerService)

    .factory('LedgerTransactionService', LedgerTransactionService)

    .factory('AtmResidualService', AtmResidualService)
    
    .factory('LocationBranchService', LocationBranchService)

    .factory('AtmResidualDepositService', AtmResidualDepositService)

    .factory('DailyBalanceSheetService',  DailyBalanceSheetService)
    
    .factory('MonthlyReportService', MonthlyReportService)

    .factory('AtmCodesManagementService', AtmCodesManagementService)
    
    .factory('MobileAppService', MobileAppService)

    .factory('RouteStopService', RouteStopService)

    // .factory('AccountsService', AccountsService)

    .factory('ResetAtmCodeService', ResetAtmCodeService)

    // .factory('MobileApiService', MobileApiService)

    .factory('RouteProgressService', RouteProgressService)

    .factory('CarrierBranchService', CarrierBranchService)

    .factory('ServiceOrderService', ServiceOrderService)

    .factory('ActionCodeService', ActionCodeService)

    .factory('ServiceChecklistService', ServiceChecklistService)

    .factory('VehicleLockerService', VehicleLockerService)

    .factory('UserBranchFundingSourceService', UserBranchFundingSourceService)

    .factory('BranchPerformanceService', BranchPerformanceService)

    .factory('CashDeliveriesService', CashDeliveriesService)

    .factory('ReportService', ReportService)

    .factory('PhysicalCashCountService', PhysicalCashCountService)

    .factory('ConfigService', ConfigService)
    
    .factory('LockOpenErrorService', LockOpenErrorService)

    .factory('BillableEventsService', BillableEventsService)

    .factory('BillingCategoryService', BillingCategoryService)

    .factory('BillingRecordsService', BillingRecordsService)

    .factory('FuelSurchargeService', FuelSurchargeService)

    .factory('PricePointService', PricePointService)

    .factory('CountVariancesService', CountVariancesService)

    .factory('VaultOperationsService', VaultOperationsService)

    .factory('RouteStatsService', RouteStatsService)

    .factory('BranchFundingSourceHolidayService', BranchFundingSourceHolidayService)

    .factory('BranchFundingSourceOrderProfileService', BranchFundingSourceOrderProfileService)

    .factory('CommonLayoutService', CommonLayoutService)

    .factory('OrderViewService', OrderViewService)

    .factory('RegionRoutingService', RegionRoutingService)

    .factory('RestoreRouteAssignmentService', RestoreRouteAssignmentService)

    .factory('ServiceTicketPartsService',  ServiceTicketPartsService)

    .factory('EnvironmentConfigService',  EnvironmentConfigService)

    .factory('ContactRequestService', ContactRequestService)

    .factory('ImportFileViewService', ImportFileViewService)

    .factory('StopSchedulingService', StopSchedulingService)

    .factory('CostCenterService', CostCenterService)
    
    .factory('LocationZoneService', LocationZoneService)

    .factory('LocationDistanceService', LocationDistanceService)

    .factory('ItemTypeService', ItemTypeService)

    .factory('ContractTypeService',ContractTypeService)

    .factory('AtmMakesService', AtmMakesService)

    .factory('AutomatedRoutingStopsService', AutomatedRoutingStopsService)

    .factory('ServiceActionPrioritiesService', ServiceActionPrioritiesService)

    .name;

export default servicesModule;



// WEBPACK FOOTER //
// ./client/app/services/index.js